/**
 * All different types of items, that are accepted by DEXF.
 */
enum ItemTypeEnum {
	art = 'ART',
	spr = 'SPR',
	ext = 'EXT',
	asl = 'ASL',
	msc = 'MSC',
	asm = 'ASM',
	asp = 'ASP'
}

export default ItemTypeEnum;
